import React, { createContext, useContext } from 'react'

const FormSectionContext = createContext({ sectionPath: [] as string[] })

export const useFormSection = (name?: string) => {
  const { sectionPath } = useContext(FormSectionContext)

  const finalPath = name ? [...sectionPath, name] : sectionPath
  return {
    sectionPath: finalPath,
    fieldName: finalPath.join(".")
  }
}

export const FormSectionRootProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <FormSectionContext.Provider value={{ sectionPath: [] }}>
      {children}
    </FormSectionContext.Provider>
  )
}

export const FormSectionProvider: React.FC<{ name?: string, children: React.ReactNode }> = ({ name, children }) => {
  const { sectionPath } = useFormSection(name)
  return (
    <FormSectionContext.Provider value={{ sectionPath }}>
      {children}
    </FormSectionContext.Provider>
  )
}